module.exports = __webpack_public_path__ + "static/media/su-led-01.4b0cbe42.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/primus/su-led-01.jpg
// module id = 436
// module chunks = 0